import r from "../managers/braze-instance.js";
import ra from "./push-manager-factory.js";
export function unregisterPush(e, n) {
  if (r.rr()) return ra.ea().unsubscribe(e, n);
}
